module.exports = __webpack_public_path__ + "static/img/friend9.9ba68cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend9.jpg
// module id = 0PNJ
// module chunks = 1